<template>
  <div class="modelList_box">
    <div class="app_container">
      <div class="modelList_header">
        <ul class="modelList_items">
          <li
            class="modelList_item"
            v-for="(chart, index) in showList"
            v-bind:key="index"
          >
            <div
              class="modelList_thumbnails senChart_img_box"
              v-bind:style="{
                backgroundImage: 'url(\'' + chart.preview + '\'',
              }"
              v-on:click="viewSenChart(chart, index, true)"
              title="预览图表"
            >
              <span class="indexAPP" @click.stop="viewSenChart"
                ><i>{{ index + 1 }}</i></span
              >
            </div>
            <hr />
            <div class="modelList_info projectList_info">
              <div class="author_info city_author_info">
                <a class="tooltip-box top" style="cursor: auto">
                  <img
                    class="author_headImg"
                    src="../../static/img/daping.png"
                  />
                </a>
                <span
                  class="author_name"
                  style="max-width: 200px"
                  v-on:click="viewSenChart(chart, index)"
                  v-html="$options.filters.highLightMsg(chart.name)"
                  v-bind:title="chart.name"
                  @dblclick="selectText()"
                  >{{ chart.name }}</span
                >
              </div>
              <div class="model_info">
                <div
                  class="model_seen model_time tooltip-box top"
                  v-bind:data-content="processingTime(chart.createTime)"
                  v-on:mouseenter="showTooltip"
                  v-on:mouseleave="cancelTooltip"
                >
                  <i class="fa fa-calendar fa-fw"></i>
                </div>
                <div class="model_price tooltip-box top" data-content="图表售价" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                    <i class="fa fa-yen fa-fw"></i>{{chart.price}}
                </div>
                <div
                  class="model_seen tooltip-box top"
                  data-content="浏览次数"
                  v-on:mouseenter="showTooltip"
                  v-on:mouseleave="cancelTooltip"
                >
                  <i class="fa fa-eye fa-fw"></i>{{ formatNumber(chart.view) }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="modelList_footer">
        <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
        <div
          class="load_more_btn"
          v-on:click="loadMore"
          v-if="!isLastPage && isLoadComplete"
        >
          加载更多<i class="fa fa-arrow-circle-o-down"></i>
        </div>
        <h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "../assets/js/eventBus.js";
import crypto from "crypto-browserify";
import Identicon from "identicon.js";
import shield from "../assets/js/shield.js";
var vm;
export default {
  name: "chart_box",
  components: {},
  data: function () {
    return {
      Path: "https://www.thingjs.com/citybuilder_console/",
      viewPath:
        "https://www.thingjs.com/citybuilder/#/projectPreview?model=preview&logo=false&template=false",
      imgPath: "https://www.thingjs.com",
      showList: [],
      queryData: {
        type: "",
        bigType: "",
        smallType: "",
        keyWord: "",
        pageSize: 24,
        pageNumber: 1,
        sort: "zonghe",
      },
      isLastPage: false,
      message: [],
      infoShow: false,
      chartListNum: "",
      index: 0,
      isLoadComplete: false,
      panelShow: false,
      openUrl: "",
    };
  },
  methods: {
    selectText() {
      document
        .getSelection()
        .selectAllChildren(document.getSelection().focusNode.parentNode);
      document.execCommand("copy");
    },
    disposeUrl: function (url, userNick) {
      if (!!url) {
        var urlHeader = url.substring(0, 4);
        if (urlHeader == "http") {
          return url;
        } else {
          return this.imgPath + url;
        }
      } else {
        if (userNick == null) {
          userNick = "thingjs";
        }
        var hash = crypto.createHash("md5");
        hash.update(userNick);
        var imgData = new Identicon(hash.digest("hex")).toString();
        var imgUrl = "data:image/png;base64," + imgData;
        return imgUrl;
      }
    },
    formatBytes: function (bytes, decimals) {
      if (bytes === 0) return " -- ";
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ["B", "K", "M", "G", "T", "PB", "EB", "ZB", "YB"];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return " " + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
    },
    querySenChartList: function (data) {
      var _this = this;
      var _list = this.showList;
      _this.isLoadComplete = true;
      this.$reqs
        .post("/scene/senChart", data)
        .then(function (result) {
          console.log("result: ", result);
          if (result && result.data.state) {
            var content = result.data.content;
            var contentLen = content.length;
            bus.$emit("changeListCount", result.data.recordCount);
            _this.chartListNum = result.data.recordCount;
            for (var i = 0; i < contentLen; i++) {
              _list.push(content[i]);
            }
            // console.log(_list);
            _this.isLastPage =
              result.data.recordCount <=
              result.data.pageNumber * result.data.pageSize;
          } else {
            console.log("querySenChartList error");
          }
        })
        .catch(function (error) {
          console.log("querySenChartList error" + error);
        });
    },
    showTooltip: function (event) {
      var content = $(event.target).data("content");
      var tipEle =
        '<div class="tooltips"><div class="arrow"></div>' + content + "</div>";
      $(event.target).append(tipEle);
    },
    cancelTooltip: function (event) {
      $("div").remove(".tooltips");
    },
    showTooltip1: function (event) {
      var content = $(event.target).data("content");
      var tipEle =
        '<div class="tooltips"><div class="arrow"></div>' + content + "</div>";
      $(event.target).append(tipEle);
      var leftPx = Number("-" + parseInt($(".tooltips").width()) / 2);
      $(".modelList_info .city_author_info .top .tooltips").css({
        left: leftPx,
        "transition-duration": "0s",
      });
    },
    cancelTooltip1: function (event) {
      $("div").remove(".tooltips");
      $(".modelList_info .city_author_info .top .tooltips").css({
        left: "0px",
        "transition-duration": "0s",
      });
    },
    formatNumber: function (number) {
      if (number < 1000) {
        return number;
      } else {
        return (number / 1000).toFixed(1) + "k";
      }
    },
    loadMore: function () {
      this.queryData.pageNumber++;
      this.querySenChartList(this.queryData);
    },
    processingUrl: function (path) {
      var backPath = path.toString().replace(/\\/g, "/");
      return this.Path + backPath;
    },
    processingTime: function (time) {
      var str = time.toString();
      return str;
    },
    zoomdiv: function () {
      let zoomicon = document.getElementsByClassName("zoom_icon")[0];
      let listInfo = document.getElementById("list_info");
      let infoBottom = document.getElementById("info_bottom");
      if (zoomicon.alt == "shrink") {
        listInfo.className = "modelList_infoShow cityShow";
        infoBottom.className = "info_bottom";
        $(".kefuBtn").show();
        $(".qqBtn").show();
        $(".wxBtn").show();
        zoomicon.src = "../../static/img/最大化.png";
        zoomicon.alt = "maximize";
      } else if (zoomicon.alt == "maximize") {
        listInfo.className = "modelList_infoShow_max cityShow";
        infoBottom.className = "info_bottom_max";
        $(".kefuBtn").hide();
        $(".qqBtn").hide();
        $(".wxBtn").hide();
        zoomicon.src = "../../static/img/最小化.png";
        zoomicon.alt = "shrink";
      }
    },
    closediv: function () {
      $(".kefuBtn").show();
      $(".qqBtn").show();
      $(".wxBtn").show();
      if ($(".fullScreen").hasClass("tuichu")) {
        this.large();
      }
      this.infoShow = false;
    },
    viewSenChart: function (chart, index, flag) {
      var _this = this;
      if ($.cookie("openid")) {
        var openUrl =
          "https://charts.thingjs.com/nanshan/preview/publish/" +chart.publishId;
        window.open(openUrl, "_blank");
        _this.$reqs.get("/scene/addSenChartView?id="+chart.id).then(function(result) {})
      } else {
        logoinForStore();
      }
    },
    large: function () {
      var _this = this;
      var parentF = "";
      var id = "";
      parentF = ".modelList_infoShow";
      id = "#myframeC";
      if ($(".fullScreen").hasClass("tuichu")) {
        $(parentF).removeClass("quanping");
        $(id).removeClass("fullFrame");
        $(".fullScreen").removeClass("tuichu");
        $("html").css("overflow-y", "scroll");
        $(".popContainer").show();
        $(".fullScreenClose").hide();
        // $('.navHeader').hide();
      } else {
        $(".fullScreen").addClass("tuichu");
        $(parentF).addClass("quanping");
        $(id).addClass("fullFrame");
        $("html").css("overflow-y", "hidden");
        $(".fullScreenClose").show();
        $(".popContainer").hide();
        $(".navHeader").show();
      }
    },
    hidePanel: function (success) {
      var _this = this;
      this.panelShow = false;
    },
  },
  beforeCreate() {
    vm = this;
  },
  beforeDestroy() {
    bus.$off("addSenChartList");
    bus.$off("changeSenChartList");
    bus.$off("showSenChartNull");
  },
  mounted() {
    var _this = this;
    if (shield.shieldWords.indexOf($("#keyword").val()) == "-1") {
      this.queryData.keyWord = $("#keyword").val();
    }
    this.queryData.sort = $(".active").attr("data-sort");
    this.querySenChartList(this.queryData);
    bus.$on("changeSenChartList", (data) => {
      this.showList = [];
      this.querySenChartList(data);
      this.queryData = JSON.parse(JSON.stringify(data));
    });
    bus.$on("showSenChartNull", (data) => {
      this.showList = [];
      bus.$emit("changeListCount", "-1");
      this.isLastPage = true;
    });
    bus.$on("addSenChartList", (data) => {
      _this.queryData.pageNumber++;
      this.querySenChartList(_this.queryData);
    });
    bus.$on("chartList", (data) => {
      this.viewSenChart(data, false);
    });
  },
  filters: {
    highLightMsg: function (value) {
      if (vm.queryData && vm.queryData.keyWord) {
        var reg = new RegExp(vm.queryData.keyWord, "g");
        if (value.indexOf(vm.queryData.keyWord) != -1) {
          return value.replace(
            reg,
            '<span class="highlight">' + vm.queryData.keyWord + "</span>"
          );
        } else {
          return value;
        }
      } else {
        return value;
      }
    },
    highLightkeyWord: function (value) {
      if (vm.queryData && vm.queryData.keyWord) {
        var reg = new RegExp(vm.queryData.keyWord, "g");
        if (value.indexOf(vm.queryData.keyWord) != -1) {
          return value.replace(
            reg,
            '<span class="highlight">' + vm.queryData.keyWord + "</span>"
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SenChart.vue